import React, { Component } from 'react';

class CustomerExtraDelivery extends Component{
  constructor(props) {
    super(props);
    this.state = {
      extra_delivery: props.extra_delivery
    };
  }

  toggleExtraDelivery = () => {

    const cart = {cart: this.props.id}
    const token = localStorage.getItem("admin-token")
    const body = JSON.stringify(cart);
    console.log(body)
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;

    if (this.state.extra_delivery){
      fetch(`/api/admin/extra-delivery/remove`, {headers, body, method: "POST"})
        .then(res => {
          if (res.status === 200) {
            this.setState({ extra_delivery: false })
          } else {
            console.log("Server Error!");
            throw res;
          }
        })
    } else {
      fetch(`/api/admin/extra-delivery/add`, {headers, body, method: "POST"})
        .then(res => {
          if (res.status === 200) {
            this.setState({ extra_delivery: true })
          } else {
            console.log("Server Error!");
            throw res;
          }
        })
    }
  }

  render() {
    return(
      <div key={this.props.month}>
        <label>
          <input
            type="checkbox"
            name={this.state.month}
            className="CustomerExtraDelivery-check"
            checked={this.state.extra_delivery}
            onChange={this.toggleExtraDelivery} />
          {this.props.month__name}
        </label>
      </div>
    )
  }
}

export default CustomerExtraDelivery



// WEBPACK FOOTER //
// ./src/containers/admin/components/CustomerExtraDelivery.jsx